import { z } from 'zod/v4';

export const addressSchema = z.object({
  streetAddress: z.string().nullable(),
  extendedAddress: z.string().nullable(),
  streetNumber: z.number().nullable(),
  streetName: z.string().nullable(),
  city: z.string().nullable(),
  county: z.string().nullable(),
  state: z.object({
    name: z.string().nullable(),
    abbrv: z.string().nullable(),
  }),
  country: z.object({
    name: z.string().nullable(),
    abbrv: z.string().nullable().optional(),
  }),
  postalCode: z.string().nullable(),
});

export type Address = z.infer<typeof addressSchema>;
